import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveLifestyleSelectedOptions as resolveOptions,
  resolveLifestyleOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_clear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_clear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_grey_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_grey_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_black_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_navy_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_navy_{nnn}.png',
    },
    navytortoise: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_blue_tort_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_blue_tort_{nnn}.png',
    },
    blacktortoise: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_black_tort_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_black_tort_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_stone_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_stone_{nnn}.png',
    },
    tortoise: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_brown_tort_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_brown_tort_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/250725/sierras/sf_white_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sf_white_{nnn}.png',
    },
    desertsand: {
      pathTemplate: 'gs://sg360/260311/sf_Idesertsand--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260311/sf_Idesertsand--{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/250725/sierras/si_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_black_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/250725/sierras/si_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_blue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/250725/sierras/si_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_gold_{nnn}.png',
    },
    Bgreen: {
      pathTemplate: 'gs://sg360/250725/sierras/si_green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_green_{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/250725/sierras/si_red_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_red_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/250725/sierras/si_silver_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_silver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/250725/sierras/si_white_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_white_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/250725/sierras/si_rosegold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/si_rosegold_{nnn}.png',
    },
    Bpink: {
      pathTemplate: 'gs://sg360/260811/si_pink_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260811/si_pink_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/260811/si_gunmetal_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260811/si_gunmetal_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    blue: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_blue_{nnn}.png',
    },
    brown: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_brown_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_brown_{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_fire_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_fire_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_gold_{nnn}.png',
    },
    green: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_green_{nnn}.png',
    },
    rose: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_rose_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_rose_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_bluesilver_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_bluesilver_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/250725/sierrase/sle_smoke_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/sierras/sle_smoke_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/270624/Sierras/sle/sle_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/270624/Sierras/sle/sle_clear_{nnn}.png',
    },
  },
}

export const reflection = {
  id: 'reflections',
  isReflection: true,
  name: 'Reflections',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    r5pc: {
      pathTemplate: 'gs://sg360/220520/Sierras/sle Cloud Overlay/5/Sierras_Cloud Overlay 5_{nnn}.png',
    },
    r10pc: {
      pathTemplate: 'gs://sg360/220520/Sierras/sle Cloud Overlay/10/Sierras_Cloud Overlay 10_{nnn}.png',
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220520/Sierras/slg/slg_N_{nnn}.png',
    },
    eP: {
      pathTemplate: 'gs://sg360/220520/Sierras/slg/slg_P_{nnn}.png',
    },
    e8: {
      pathTemplate: 'gs://sg360/220520/Sierras/slg/slg_8_{nnn}.png',
    },
    e8P: {
      pathTemplate: 'gs://sg360/220520/Sierras/slg/slg_8P_{nnn}.png',
    },
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/250725/sierras/s_background_{nnn}.png',
    },
  },
}

export default {
  layers: [background, frame, icons, lenses, engraving, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
